<template>
  <div class="flex flex-col w-[28rem]">
    <div class="bg-neutral-secondary rounded-md px-4 py-3 mb-2">
      <div class="grid grid-flow-row grid-cols-3">
        <NText
          variant="caption1"
          weight="medium"
          class="text-neutral-secondary-press pb-3 self-center col-span-1"
        >
          {{ t('modules.portfolio.symbol') }}
        </NText>

        <NText
          variant="caption1"
          weight="medium"
          class="flex justify-end items-center text-neutral-secondary-press pb-3 col-span-2"
        >
          {{ item.instrumentName }}
        </NText>

        <NText
          variant="caption1"
          weight="medium"
          class="text-neutral-secondary-press pb-3 self-center col-span-1"
        >
          {{ t('common.date') }} {{ t('common.submit_request') }}
        </NText>

        <NText
          variant="caption1"
          weight="medium"
          class="flex justify-end items-center text-neutral-secondary-press pb-3 col-span-2"
        >
          {{ d(item.requestDate, 'shortDate') }} ,
          {{ d(item.requestDate, 'shortTime') }}
        </NText>

        <NText
          variant="caption1"
          weight="medium"
          class="text-neutral-secondary-press border-b border-neutral-secondary pb-3 self-center col-span-1"
        >
          {{ t('common.requestStatus') }}
        </NText>

        <NText
          weight="medium"
          variant="caption1"
          class="flex justify-end items-center text-neutral-secondary-press border-b border-neutral-secondary pb-3 col-span-2"
        >
          {{ item.requestState }}
        </NText>

        <NText
          variant="caption1"
          weight="medium"
          class="text-neutral-secondary-press border-b border-neutral-secondary py-3 self-center col-span-1"
        >
          {{ t('common.description') }}
        </NText>

        <NText
          variant="caption1"
          weight="medium"
          class="flex justify-end items-center text-neutral-secondary-press border-b border-neutral-secondary py-3 col-span-2"
        >
          {{ item.requestDescription }}
        </NText>

        <NText
          variant="caption1"
          weight="medium"
          class="text-neutral-secondary-press pt-3 self-center col-span-1"
        >
          {{ t('deposit.requestCode') }}
        </NText>

        <NText
          variant="caption1"
          weight="medium"
          class="flex justify-end items-center text-neutral-secondary-press pt-3 col-span-2"
        >
          {{ item.requestSerialNumber }}
        </NText>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { GetBrokerChangeItem } from '@libs/api-reference';

type BrokerChangesItem = {
  item: GetBrokerChangeItem;
};

defineProps<BrokerChangesItem>();

const { t, d } = useI18n();
</script>
